var exports = {
  "L": "xe533113f--f4cb13--loading",
};

module.exports = exports;
